import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
export var jsonKeys = [
    "dimBranchIDList",
    "dimProductPriceIDList"
];
export var allowedFields = [
    "startDate",
    "endDate",
    "isAllProduct"
].concat(_to_consumable_array(jsonKeys));
